import extend from 'extend';
import Q from 'q';
import _ from 'underscore';

import web_wallet_buyer_recharge_getPayChannel from '../../../../../lib/data-service/wallet/web_wallet_buyer_recharge_getPayChannel';
import wallet_pay_accountRecharge from '../../../../../lib/data-service/default/wallet_pay_accountRecharge';

import payment_notifyResult from '../../../../../lib/data-service/payment/payment_notifyResult';

import BasePaymentMethodSelector from '../component/base-payment-method-selector/index.vue';

import mock_data_helper from './lib/mock_data_helper';
import QRCode from "qrcode";
import call_ccb_pc_data_interface
    from "yinzhilv-js-sdk/frontend/common-project/lib/common-service/yinzhilv/call_ccb_pc_data_interface";
import call_UnionPay_b2b_data_interface
    from "yinzhilv-js-sdk/frontend/common-project/lib/common-service/yinzhilv/call_UnionPay_b2b_data_interface";
import call_UnionPay_b2c_data_interface
    from "yinzhilv-js-sdk/frontend/common-project/lib/common-service/yinzhilv/call_UnionPay_b2c_data_interface";
import icbc_jufutong_open_page
    from "yinzhilv-js-sdk/frontend/common-project/lib/common-service/yinzhilv/icbc-jufutong/open_page";

export default {
    mixins: [
        BasePaymentMethodSelector,
    ],
    data() {
        return {
            payWaitDialog: false,
            init_parameter: {

                mock_data: {
                    enable: false,
                },

                btn_pay: {
                    text: `确认充值`,
                },

                count_down: {
                    enable: false,
                    pay_remaining_seconds: 0, //支付剩余时间，以秒为单位
                },

                //在这里调用获取支付方式的接口
                get_payment_channel_entity_list(args) {
                    const __this = this;

                    const init_parameter = __this.init_parameter;

                    const mock_data = init_parameter.mock_data;
                    const enable_mock_data = mock_data.enable;
                    const wait_seconds = mock_data.wait_seconds;

                    const data_get_params = __this.data_get_params;
                    const companyId = data_get_params.companyId;
                    const orderAmount = data_get_params.orderAmount;

                    return Q.when()
                        .then(function () {
                            if (enable_mock_data) {
                                return mock_data_helper.get_payment_channel_entity_list({
                                    wait_seconds,
                                });
                            }

                            return web_wallet_buyer_recharge_getPayChannel({
                                companyId: companyId,
                                isUseCredit: false,
                                payAmount: orderAmount,
                                type: 3,
                            });
                        })
                        .then(function (data) {
                            const paymentChannels = data.paymentChannels;
                            const payment_channel_entity_list = paymentChannels;
                            return Q.resolve({
                                payment_channel_entity_list,
                                data_get_payment_channel_entity_list: data,
                            });
                        })
                        ;
                },

                //在这里调用支付的接口
                pay(args) {
                    const __this = this;

                    const init_parameter = __this.init_parameter;
                    const mock_data = init_parameter.mock_data;
                    const enable_mock_data = mock_data.enable;
                    const wait_seconds = mock_data.wait_seconds;

                    const selected_payment_channel_entity_list = args.selected_payment_channel_entity_list;
                    const password = args.password;

                    // const paymentChannelVos = _.chain(selected_payment_channel_entity_list)
                    //     .map(function (m) {
                    //         const payment_amount_number = m.payment_amount_number;
                    //         const code = m.code;
                    //         const o = {};
                    //         o.amount = payment_amount_number;
                    //         o.paymentChannel = code;
                    //         return o;
                    //     })
                    //     .value()
                    // ;

                    const selected_payment_channel_entity_exclude_shouxin_zhifu = __this.selected_payment_channel_entity_exclude_shouxin_zhifu;
                    const paymentChannel = selected_payment_channel_entity_exclude_shouxin_zhifu.code;

                    return Q.when()
                        .then(function () {
                            if (enable_mock_data) {
                                return mock_data_helper.pay({
                                    wait_seconds,
                                });
                            }

                            const orderNo = __this.data_get_params.orderNo;
                            const orderAmount = __this.data_get_params.orderAmount;

                            return wallet_pay_accountRecharge({
                                orderNo: orderNo,
                                totalFee: orderAmount,
                                paymentChannel: paymentChannel,
                                phone: __this.phoneForm.phone,
                            });
                        })
                        .then(function (data) {
                            const outTradeNo = data.outTradeNo;
                            const resultMap = data.resultMap;
                            const htmlStr = data.htmlStr;
                            return Q.resolve({
                                original_data: data,
                                outTradeNo,
                                resultMap,
                                htmlStr,
                            });
                        })
                        ;
                },

                //在这里调用检查支付状态的接口（不用实现轮询逻辑，轮询逻辑由内部实现）
                check_payment_status(args) {
                    const __this = this;

                    const init_parameter = __this.init_parameter;

                    const mock_data = init_parameter.mock_data;
                    const enable_mock_data = mock_data.enable;
                    const wait_seconds = mock_data.wait_seconds;

                    const outTradeNo = args.outTradeNo;

                    return Q.when()
                        .then(function () {
                            if (enable_mock_data) {
                                return mock_data_helper.check_payment_status({
                                    wait_seconds,
                                });
                            }

                            return payment_notifyResult({
                                tradeNo: outTradeNo,
                            });
                        })
                        .then(function (data) {
                            const paymentStatus = data.paymentStatus;
                            return Q.resolve({
                                paymentStatus,
                                original_data: data,
                            });
                        })
                        ;
                },

                //在这里设置支付状态的定义（枚举值）
                get_payment_status_define() {
                    // 支付状态：0：已失效 1：支付中 2：已支付 3：支付失败
                    const payment_status_success = 2;
                    const payment_status_failure = 3;
                    return {
                        payment_status_success,
                        payment_status_failure,
                    };
                },

            },
        }
    },
    methods: {
        __checkPhoneForm() {
            return new Promise((resolve) => {
                if (this.activePayInfo.code !== 17) {
                    resolve(true)
                } else {
                    this.$refs.phoneForm[0].validate(valid => {
                        resolve(valid)
                    })
                }
            })
        },
        async __btn_pay_click() {
            const __this = this;
            let checkRes = await this.__checkPhoneForm();
            if (!checkRes) {
                return
            }
            const btn_pay = __this.btn_pay;
            const __init_can_choose_payment_channel = __this.__init_can_choose_payment_channel;

            if (btn_pay.is_loading) return;
            btn_pay.is_loading = true;
            __init_can_choose_payment_channel({
                flag: false,
            });

            const payment_channel_entity_list = __this.payment_channel_entity_list;
            const selected_payment_channel_entity_code_list = __this.selected_payment_channel_entity_code_list;
            const __selected_payment_channel_entity_list = __this.selected_payment_channel_entity_list;
            const selected_payment_channel_entity_list = _.chain(__selected_payment_channel_entity_list)
                .map(function (m) {
                    return extend(true, {}, m);
                })
                .value()
            ;

            const pay = __this.init_parameter.pay;
            // console.log(`__this.selected_payment_channel_code_for_select_mode_single_choice=${__this.selected_payment_channel_code_for_select_mode_single_choice}`);
            // console.log(`__this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice=${__this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice}`);
            // console.log(`__this.selected_payment_channel_code_for_select_mode_multiple_choice=${__this.selected_payment_channel_code_for_select_mode_multiple_choice}`);
            // console.log(selected_payment_channel_entity_list);
            // return;


            if (__this.panel_qing_song_fu.is_checked) {
                //如果用户勾选了轻松付
                //新增一个授信的支付方式，并且金额传入获取轻松付接口返回数据的尾款金额
                const ableAmount = __this.data_get_qing_song_fu_data.ableAmount;
                selected_payment_channel_entity_list.push({
                    // amount: 0,
                    // amount_number: 0,
                    // amount_string: "0.00",
                    code: 6,
                    // enable: true,
                    payment_amount_number: ableAmount,
                    // payment_amount_string: "0.00",
                    // pic: ""
                    // text: "",
                    // usable: true,
                });
            }

            const before_pay_event_handler = __this.init_parameter.before_pay_event_handler;
            let promise_before_pay_event_handler = Q.when();
            if (_.isFunction(before_pay_event_handler)) {
                promise_before_pay_event_handler = promise_before_pay_event_handler.then(function () {
                        return before_pay_event_handler.call(__this, {});
                    }
                );
            }

            const user_cancel_pay_event_handler = __this.init_parameter.user_cancel_pay_event_handler;

            return Q.when()
                .then(function () {
                    return promise_before_pay_event_handler;
                })
                .then(function () {
                    const list = _.chain(selected_payment_channel_entity_list)
                        .filter(function (m) {
                            //需要输入支付密码的支付方式
                            //6:胤之旅授信支付
                            //24:浩旅授信支付
                            //4:胤之旅游钱包支付
                            //23:浩旅钱包支付
                            return 1 === 1
                                && _.contains([6, 24, 4, 23], m.code)
                                ;
                        })
                        .value();
                    if (list.length > 0) {
                        //如果用户选择的是钱包支付
                        return __this.$prompt("", "请输入支付密码", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            inputType: "password",
                            closeOnClickModal: false,
                            inputValidator(pValue) {
                                const flag = !!pValue;
                                return flag;
                            },
                            inputErrorMessage: `请输入支付密码！`,
                        });
                    }
                    if (__this.panel_qing_song_fu.is_checked) {
                        //如果用户勾选了轻松付
                        return __this.$prompt("", "请输入支付密码", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            inputType: "password",
                            closeOnClickModal: false,
                            inputValidator(pValue) {
                                const flag = !!pValue;
                                return flag;
                            },
                            inputErrorMessage: `请输入支付密码！`,
                        });
                    }

                    return Q.resolve({
                        value: ``,
                    });
                })
                .then(function (data) {
                    const password = data.value;

                    if (
                        _.contains(selected_payment_channel_entity_code_list, 3) ||
                        _.contains(selected_payment_channel_entity_code_list, 9) ||
                        _.contains(selected_payment_channel_entity_code_list, 10) ||
                        _.contains(selected_payment_channel_entity_code_list, 7) ||
                        _.contains(selected_payment_channel_entity_code_list, 8) ||
                        _.contains(selected_payment_channel_entity_code_list, 5) ||
                        _.contains(selected_payment_channel_entity_code_list, 22)
                    ) {
                        //如果选择的支付方式，包含：
                        //3:个人网银
                        //9:企业银联
                        //10:个人信用卡网银
                        //7:
                        //8:
                        //5:易宝
                        //22:原始支付宝扫码支付
                        //即打开第三方支付界面的支付方式，
                        //打开第三方支付界面后，
                        //仍然可以在当前页面重新支付，
                        //仍然可以在当前页面选择支付方式
                        __this.__init_can_choose_payment_channel({
                            flag: true,
                        });
                        __this.__init_payment_channel_entity_shouxin_zhifu_enable();
                        __this.__init_payment_channel_entity_qianbao_zhifu_enable();
                    } else {
                        __this.__init_can_choose_payment_channel({
                            flag: false,
                        });
                        __this.__init_payment_channel_entity_shouxin_zhifu_enable();
                        __this.__init_payment_channel_entity_qianbao_zhifu_enable();
                    }

                    return pay.call(__this, {
                        selected_payment_channel_entity_list,
                        password,
                    });
                })
                .then(function (data) {
                    __this.data_pay = data;

                    //获取非授权支付外的另一个支付方式
                    const payment_channel_entity =
                        __this.selected_payment_channel_entity_exclude_shouxin_zhifu;

                    if (!payment_channel_entity.code) {
                        //找不到非授权支付的另一个支付方式
                        //即单选模式，并且只选择了授信支付
                        return Q.resolve();
                    }

                    //4:胤之旅钱包支付
                    if (payment_channel_entity.code === 4) {
                        return Q.resolve();
                    }

                    //23:浩旅钱包支付
                    if (payment_channel_entity.code === 23) {
                        return Q.resolve();
                    }

                    //1:建行龙存管的微信扫码支付
                    if (payment_channel_entity.code === 1) {
                        const resultMap = data.resultMap;
                        const WECHAT = resultMap.WECHAT;
                        return QRCode.toDataURL(WECHAT).then(function (url) {
                            __this.dialog_qrcode.title = `请使用<span class="font-strong">微信</span>扫描二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.close_situation = `000`;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    //2:建行龙存管的支付宝扫码支付
                    if (payment_channel_entity.code === 2) {
                        const resultMap = data.resultMap;
                        const ALIPAY = resultMap.ALIPAY;
                        return QRCode.toDataURL(ALIPAY).then(function (url) {
                            __this.dialog_qrcode.title = `请使用<span class="font-strong">支付宝</span>扫描二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.close_situation = `000`;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    //19:工银聚合支付微信支付
                    if (payment_channel_entity.code === 19) {
                        const resultMap = data.resultMap;
                        const qrcodeUrl = resultMap.qrcodeUrl;
                        return QRCode.toDataURL(qrcodeUrl).then(function (url) {
                            __this.dialog_qrcode.title = `请使用<span class="font-strong">微信</span>扫描二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.close_situation = `000`;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    //20:工银聚合支付支付宝支付
                    if (payment_channel_entity.code === 20) {
                        const resultMap = data.resultMap;
                        const qrcodeUrl = resultMap.qrcodeUrl;
                        return QRCode.toDataURL(qrcodeUrl).then(function (url) {
                            __this.dialog_qrcode.title = `请使用<span class="font-strong">支付宝</span>扫描二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.close_situation = `000`;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    //3:个人网银
                    //9:企业网银
                    //10:个人信用卡网银
                    if (_.contains([3, 9, 10], payment_channel_entity.code)) {
                        const resultMap = data.resultMap;
                        const BODY = resultMap.BODY;
                        const CONTENTTYPE = resultMap.CONTENTTYPE;
                        const INFO = resultMap.INFO;
                        const SIGN = resultMap.SIGN;
                        return call_ccb_pc_data_interface({
                            BODY,
                            CONTENTTYPE,
                            INFO,
                            SIGN,
                        }).then(function () {
                            btn_pay.is_loading = false;
                        });
                    }

                    //7:企业银联
                    if (payment_channel_entity.code === 7) {
                        const resultMap = data.resultMap;
                        return call_UnionPay_b2b_data_interface(resultMap).then(function () {
                            btn_pay.is_loading = false;
                        });
                    }

                    //8:个人银联
                    if (payment_channel_entity.code === 8) {
                        const resultMap = data.resultMap;
                        return call_UnionPay_b2c_data_interface(resultMap).then(function () {
                            btn_pay.is_loading = false;
                        });
                    }

                    //5:易宝支付
                    if (payment_channel_entity.code === 5) {
                        const htmlStr = data.htmlStr;
                        global.open(htmlStr);
                        btn_pay.is_loading = false;
                        return Q.resolve();
                    }

                    //14:工行聚富通b2c
                    if (payment_channel_entity.code === 14) {
                        const htmlStr = data.htmlStr;
                        icbc_jufutong_open_page({
                            htmlStr,
                        });
                        btn_pay.is_loading = false;
                        return Q.resolve();
                    }

                    //17:工行聚富通b2b
                    if (payment_channel_entity.code === 17) {
                        const htmlStr = data.htmlStr;
                        //const url_001 = `yinzhilv-open-ie:${htmlStr}`;
                        //const url_002 = url_001.replace(/&/gi, `yinzhilv-open-ie-separator`);//一定要将&替换成yinzhilv-open-ie-separator，否则参数会丢失
                        //global.open(url_002);
                        global.open(htmlStr);
                        btn_pay.is_loading = false;
                        return Q.resolve();
                    }

                    //21:原始的微信扫码支付
                    if (payment_channel_entity.code === 21) {
                        const datas = data.datas;
                        const htmlStr = datas.htmlStr;
                        return QRCode.toDataURL(htmlStr).then(function (url) {
                            __this.dialog_qrcode.title = `请打开微信扫码本二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.close_situation = `000`;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    //22:原始的支付宝扫码支付
                    if (payment_channel_entity.code === 22) {
                        const datas = data.datas;
                        const htmlStr = datas.htmlStr;

                        const wnd = window.open(`about:blank`, `_blank`);
                        wnd.document.write(htmlStr);

                        btn_pay.is_loading = false;
                    }

                    //25:原始的支付宝app支付
                    if (payment_channel_entity.code === 25) {
                        const datas = data.datas;
                        const orderInfo = datas.htmlStr;

                        const __pay = function ({orderInfo}) {
                            const api = global.api;
                            const aliPayPlus = api.require("aliPayPlus");
                            const defer = Q.defer();
                            aliPayPlus.payOrder(
                                {
                                    orderInfo,
                                },
                                function (ret, err) {
                                    if (err) {
                                        defer.reject({
                                            err,
                                        });
                                        return;
                                    }
                                    defer.resolve({
                                        ret,
                                    });
                                }
                            );
                            return defer.promise;
                        };

                        return Q.when()
                            .then(function () {
                                return __pay({orderInfo});
                            })
                            .then(function ({ret}) {
                                const code = ret.code;
                                //https://docs.apicloud.com/Client-API/Open-SDK/aliPayPlus
                                // code:
                                //字符串类型；错误码，取值范围如下：
                                //9000：支付成功
                                //8000：正在处理中，支付结果未知（有可能已经支付成功），请查询商户订单列表中订单的支付状态
                                //4000：订单支付失败
                                //5000：重复请求
                                //6001：用户中途取消支付操作
                                //6002：网络连接出错
                                //6004：支付结果未知（有可能已经支付成功），请查询商户订单列表中订单的支付状态
                                if (code === `9000`) {
                                    return Q.resolve({
                                        ret,
                                    });
                                } else if (code === `6001`) {
                                    if (_.isFunction(user_cancel_pay_event_handler)) {
                                        user_cancel_pay_event_handler();
                                    }
                                    return Q.reject({
                                        ret,
                                        disable_log_error: true,
                                    });
                                } else {
                                    api.alert({
                                        title: "支付结果",
                                        msg: ret.code,
                                        buttons: ["确定"],
                                    });
                                    return Q.reject({
                                        ret,
                                    });
                                }
                            });
                    }

                })
                .then(function () {
                    // __this.__start_timer_to_check_payment_status();
                    __this.payWaitDialog = true;
                })
                .catch(function (ex) {
                    __this.__init_can_choose_payment_channel({flag: true});
                    __this.__init_payment_channel_entity_shouxin_zhifu_enable();
                    __this.__init_payment_channel_entity_qianbao_zhifu_enable();
                    btn_pay.is_loading = false;

                    if (ex) {
                        const enable_log_error = !ex.disable_log_error;
                        if (enable_log_error) {
                            console.error(ex);
                            console.trace();
                            if (ex.stack) {
                                console.error(ex.stack);
                            }
                        }
                    }
                    return Q.reject(ex);
                });
        },
        __dialogForPayEnd() {
            const __this = this;
            __this.payWaitDialog = false;
            __this.__init_can_choose_payment_channel({
                flag: false,
            });

            const pay_successful_event_handler =
                __this.init_parameter.pay_successful_event_handler;
            if (_.isFunction(pay_successful_event_handler)) {
                pay_successful_event_handler();
            }

        },
        __dialogForPayAgain() {
            const __this = this;
            const btn_pay = __this.btn_pay;
            __this.payWaitDialog = false;
            __this.__init_can_choose_payment_channel({flag: true});
            __this.__init_payment_channel_entity_shouxin_zhifu_enable();
            __this.__init_payment_channel_entity_qianbao_zhifu_enable();
            btn_pay.is_loading = false;
        },
    },
}
